import React, { FC, useState, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonFooter, IonHeader, IonPage, IonModal, useIonViewWillEnter } from '@ionic/react'
import { doProductMobx, productSaleMobx } from 'restaurant'
import { toastLayer, modalLayer, useHistoryNew } from '@utils'
import { format } from '@dt/fe-utils'
import { ClearModal } from '@cps'
import './modifier.scss'

const Modify: FC = (props: any) => {
  const isModal = props.isModal
  const history = useHistoryNew()
  const [modifierGroupNoIndex, setModifierGroupNoIndex] = useState(0)
  const [warn, setWarn] = useState(false)

  const modifierGroup = doProductMobx.doProduct.modifierGroups[modifierGroupNoIndex]

  const handleBack = () => {
    try {
      !isModal && history.goBack()
      if (isModal) {
        props?.reject()
        modalLayer.close('ModiferDetail')
      }
    } catch (error) { }
  }

  const choosedName = useMemo(() => {
    let choosedName = ''
    if (modifierGroup.selectMax === 1) {
      if (modifierGroup.selectMin === 0) {
        choosedName = i18n.t('productdetail.optional', { count: modifierGroup.selectMax })
      } else {
        choosedName = i18n.t('modifier.mustSelect')
      }
    } else if (modifierGroup.selectMin > 0) {
      if (modifierGroup.cnt === 0) {
        choosedName = i18n.t('modifier.selectMulit', { min: modifierGroup.selectMin, max: modifierGroup.selectMax })
      }
    }
    return choosedName
  }, [modifierGroup])

  const renderContent = () => {
    return (
      <>
        <IonHeader>
          <div className={`modify-page-title${warn ? ' warn' : ''}`}>
            <span data-cypid='modifierClose' onClick={handleBack}>
              <i className='iconfont icon-chevron-left'></i>
              <span>{modifierGroup.name}</span>
            </span>
            <small>{choosedName}</small>
          </div>
        </IonHeader>
        <IonContent>
          <div className='choose-list'>
            {
              modifierGroup.modifiers?.map(modifier => {
                const saleCnt = productSaleMobx.localScaleNoToCntMap[`${modifier.no}_0`]
                const stopSale = saleCnt && saleCnt.cnt === 0
                const price = modifier.price
                const actualPrice = !props.hideModifyDiscount && modifier.discountPrice && modifier.discountPrice > 0 ? modifier.actualPrice : modifier.price
                return (
                  <div
                    className={`choose-item ${stopSale ? 'disabled' : ''}`}
                    key={modifier.no}
                    data-cypid={`modifierChoose_no_${modifier.no}`}
                    onClick={() => {
                      if (stopSale) return
                      if (modifierGroup.mode === 'multiSingle') {
                        const result = doProductMobx.addModifier(modifierGroup.no, modifier.no, true)
                        if (result === 'MODIFIERGROUP_CNT') {
                          toastLayer.info(i18n.t('modifier.maxSelect', { name: modifierGroup.name, cnt: modifierGroup.maxCnt }))
                        } else if (result === 'MODIFIERGROUP_ITEM') {
                          toastLayer.info(i18n.t('modifier.maxSelect', { name: modifierGroup.name, cnt: modifierGroup.selectMax }))
                          // toastLayer.info(i18n.t('modifier.selectMulit', { min: modifierGroup.selectMin, max: modifierGroup.selectMax }))
                        }
                      }
                    }}
                  >
                    <span>
                      <span>{modifier.name}</span>
                      {price > 0 ? <small>{format.toPrice(actualPrice)} {actualPrice !== price && <del> {format.toPrice(price)}</del>}</small> : null}
                    </span>
                    {
                      modifierGroup.mode === 'multiSingle' ? (
                        stopSale ? <span>{i18n.t('common.soldout')}</span> : (
                          <div className='iconfont-wrapper'>
                            <i className={`iconfont ${modifier.cnt ? 'icon-checkbox--checked--filled' : 'icon-checkbox'}`}></i>
                          </div>
                        )
                      ) : (
                        <div>
                          {
                            modifier.cnt === 0 ? null : (
                              <i
                                className='iconfont icon-shuliangjian2x' data-cypid={`modifierReduce_no_${modifier.no}`} onClick={() => {
                                  doProductMobx.reduceModifier(modifierGroup.no, modifier.no)
                                }}
                              >
                              </i>)
                          }
                          {
                            modifier.cnt > 0 ? (
                              <span>{modifier.cnt}</span>
                            ) : null
                          }
                          {
                            stopSale ? <span>{i18n.t('common.soldout')}</span> : (
                              <i
                                className='iconfont icon-add'
                                data-cypid={`modifierAdd_no_${modifier.no}`}
                                onClick={() => {
                                  if (stopSale) return
                                  const result = doProductMobx.addModifier(modifierGroup.no, modifier.no)
                                  if (result === 'MODIFIER') {
                                    toastLayer.info(i18n.t('modifier.maxSelect', { name: modifier.name, cnt: modifier.maxCnt }))
                                  } else if (result === 'MODIFIERGROUP_CNT') {
                                    toastLayer.info(i18n.t('modifier.maxSelect', { name: modifierGroup.name, cnt: modifierGroup.maxCnt }))
                                  } else if (result === 'MODIFIERGROUP_ITEM') {
                                    toastLayer.info(i18n.t('modifier.maxSelect', { name: modifierGroup.name, cnt: modifierGroup.selectMax }))
                                    // toastLayer.info(i18n.t('modifier.selectMulit', { min: modifierGroup.selectMin, max: modifierGroup.selectMax }))
                                  }
                                }}
                              >
                              </i>
                            )
                          }
                        </div>
                      )
                    }
                  </div>
                )
              })
            }
          </div>
        </IonContent>
        <IonFooter>
          <div className='modifier-button-footer'>
            <button
              className='reset-btn'
              data-cypid='modifierClose'
              onClick={() => {
                modalLayer(
                  ClearModal,
                  { message: i18n.t('newCart.resetModify') },
                  'clearModal'
                )
                  .then(() => {
                    doProductMobx.clearModifierGroup(props.match.params.modifierGroupNo)
                  })
                  .catch(() => { })
              }}
            >
              {i18n.t('modifier.reset')}
            </button>
            <button
              className={`ok-btn ${!modifierGroup.isReady ? 'disabled' : ''}`}
              data-cypid='modifierConfirm'
              onClick={() => {
                if (modifierGroup.isReady) {
                  doProductMobx.saveModifierGroup()
                  handleBack()
                } else {
                  setWarn(true)
                }
              }}
            >
              {i18n.t('mkt.common.confirm')}
            </button>
          </div>
        </IonFooter>
      </>
    )
  }

  const renderPage = () => (
    <IonPage
      className='modify-page'
    >
      {renderContent()}
    </IonPage>
  )

  const renderModal = () => (
    <IonModal
      isOpen
      cssClass='modify-page'
    >
      {renderContent()}
    </IonModal>
  )

  useIonViewWillEnter(() => {
    if (!isModal && props.match.params && props.match.params.modifierGroupNo) {
      setModifierGroupNoIndex(doProductMobx.doProduct.modifierGroups.findIndex(modifierGroup => modifierGroup.no === props.match.params.modifierGroupNo))
    }
  })

  useEffect(() => {
    if (isModal && props.match.params && props.match.params.modifierGroupNo) {
      setModifierGroupNoIndex(doProductMobx.doProduct.modifierGroups.findIndex(modifierGroup => modifierGroup.no === props.match.params.modifierGroupNo))
    }
  })

  return (
    isModal ? renderModal() : renderPage()
  )
}

export default observer(Modify)
